import React, { useState } from "react";

const faqLinks = {
  tracks: "https://gent.helixconferences.com/conference-tracks/",
  abstractSubmission: "https://gent.helixconferences.com/abstract-submission/",
  schedule: "https://gent.helixconferences.com/schedule/",
  email: "mailto:hello@helixconferences.com",
};


export const faqData = [
  {
    question: "What is the GENT 2025?",
    answer:
      "GENT 2025, officially known as the “Global Summit on Graphene and Nano Technology” (GENT-2025), is a premier International Engineering conference organized by Helix Conferences. The event aims to bring together Professionals, Researchers, and Industry leaders to discuss and explore advancements in Technology.",
  },
  {
    question: "When and Where will the GENT 2025 take place?",
    answer: "The conference will be held Virtually on Sep 16, 2025.",
  },
  {
    question: "What are the highlights of GENT 2025?",
    answer:
      "Networking opportunities with Industry leaders and Professionals. Interactive Workshops and Sessions. Exhibitions showcasing Innovations, Products, and Services.",
  },
  {
    question: "What conference tracks are featured at the Expo?",
    answer: (
      <>
        You can visit the session tracks at{" "}
        <a href={faqLinks.tracks} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          here
        </a>
        .
      </>
    ),
  },
  {
    question: "How can I showcase my products and services or explore sponsorship opportunities?",
    answer: (
      <>
        For showcasing Products, Services, or exploring Sponsorship opportunities, please contact us directly at{" "}
        <a href={faqLinks.email} className="text-blue-600 underline">
          hello@helixconferences.com
        </a>
      </>
    ),
  },
  {
    question: "How can I submit an abstract for the conference?",
    answer: (
      <>
        You can submit your abstract by using this link{" "}
        <a href={faqLinks.abstractSubmission} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          here
        </a>
      </>
    ),
  },
  {
    question: "How will I receive my invoice?",
    answer:
      "Invoices will be sent to the email address provided during registration. Please check your inbox and spam folder for your invoice.",
  },
  {
    question: "What materials will I receive during the webinar?",
    answer:
      "You will receive a Conference kit which includes a name badge, a conference booklet, and a program guide upon arrival. Your name badge grants access to all sessions of the event.",
  },
  {
    question: "How long can I present my topic?",
    answer:
      "Presentation slots typically range from 15 to 20 minutes. Specific times will be assigned once your abstract is accepted.",
  },
  {
    question: "Who will be attending the GENT 2025?",
    answer:
      "This event is expected to attract a diverse group of Professionals from the Global Engineering & Technology community.",
  },
  {
    question: "How many people usually attend the Webinar?",
    answer: "We anticipate over 80 attendees, including Participants, Speakers, and Exhibitors",
  },
  {
    question: "Can I register for multiple speaking slots?",
    answer:
      "Yes, you can register for multiple speaking slots if each topic is distinct and relevant to the conference tracks. Please submit separate abstracts for each session.",
  },
  {
    question: "Are keynote speaking opportunities available?",
    answer:
      "Yes, keynote speaking slots are available. If you are interested in a Keynote position, please specify this in your abstract submission.",
  },
  {
    question: "What does being a speaker involve?",
    answer:
      "Speakers are expected to present on relevant topics, provide valuable insights, and engage with the audience. Detailed guidelines will be provided upon acceptance.",
  },
  {
    question: "Is there a cost associated with participation as a speaker or delegate?",
    answer:
      "Yes, there is a registration fee for all participants, including speakers. Check the 'REGISTER' section on our website for pricing details.",
  },
  {
    question: "How can I find out the schedule of presentations?",
    answer: (
      <>
        The schedule will be available on our website. You can download it{" "}
        <a href={faqLinks.schedule} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          here
        </a>{" "}
        You can review it to plan your participation.
      </>
    ),
  },
  {
    question: "Can I see the session list before the event?",
    answer:
      "Yes, the full confirmed agenda, including sessions along with speaker details, will be posted on our website before the event.",
  },
  {
    question: "Can I purchase tickets before the day of Webinar?",
    answer:
      "While we encourage pre-registration, a limited number of tickets may be available during one day before the webinar. Registering in advance is recommended.",
  },
  {
    question: "How can I book accommodation for the Expo?",
    answer: (
      <>
        Contact us directly at{" "}
        <a href={faqLinks.email} className="text-blue-600 underline">
          hello@helixconferences.com
        </a>{" "}
        for assistance with booking
      </>
    ),
  },
];


const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold mb-6 text-center">Frequently Asked Questions</h2>
      {faqData.map((item, index) => (
        <div key={index} className="border-b border-gray-300 mb-4">
          <button
            className="w-full text-left py-4 px-2 font-medium text-lg flex justify-between items-center"
            onClick={() => toggle(index)}
          >
            {item.question}
            <span className="text-xl">{openIndex === index ? "−" : "+"}</span>
          </button>
          {openIndex === index && (
            <div className="px-4 pb-4 text-gray-700">{item.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Faq;
